import { Reducer } from 'redux';
import {
    ActionTypes,
    GET_COMPANYVALIDATIONS_REQUEST, GET_COMPANYVALIDATIONS_SUCCESS, GET_COMPANYVALIDATIONS_FAILURE ,
    RESET_COMPANYVALIDATION_STATE
} from '../actions/companyValidations.action';


export interface CompanyValidation {
    uuid: string;
    name: string;
    alocatedValidations: number;
    allowsPrivacy: boolean;
    isActive?: boolean;
}

export interface State {
    validations: any;
    loading: boolean;
    totalCount:number;
    error: string | null;
 

}

const initialState: State = {
    validations: [],
    totalCount: 0,
    loading: false,   
    error: null,  
};

const reducer: Reducer<State, ActionTypes> = (state = initialState, action) => {
    switch (action.type) {
        case GET_COMPANYVALIDATIONS_REQUEST:
            return { ...state, loading: true, error: null };
        case GET_COMPANYVALIDATIONS_SUCCESS:
            const newVals = action.payload.page > 0 ? state.validations.concat(action.payload.validations) : action.payload.validations
            return { ...state, validations: newVals, totalCount: action.payload.totalCount, loading: false, error: null };
        case GET_COMPANYVALIDATIONS_FAILURE:
            return { ...state, loading: false, error: action.payload };       
        case RESET_COMPANYVALIDATION_STATE:
            return {...initialState}
        default:
            return state;
    }
};

export default reducer;
